import config from '../config'
import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';

var locationService = {
  data () {
    return {
      listings:[],
      allowCurrent: true,
      errorMessage: null
    }
  },
  computed: {
    /*allowDeliver(){
      if (!this.host.delivery || !this.host.delivery.deliver) return false
      if (!this.user._address || !this.user._address[0]) return true
      if (this.getDeliveryPrice(this.host.regions, this.host._address, this.user._address[0])===false) return false
      return true
    },*/
    distance() {
      if (!this.base || !this.base.coordinate || !this.address.coordinate) return this.address.$distance || 0
      return this.dist(this.base.coordinate, this.address.coordinate)
    },
    price() {
     return this.getDeliveryPrice(this.regions, this.base, this.address)
    },
  },
  methods: {
    async getLocation() {
      let coordinates
      this.allowCurrent = true
      try{
        if (Capacitor.isNativePlatform()){
          coordinates = await Geolocation.getCurrentPosition();
          //console.log('Current position:', coordinates);
        }else if (navigator && navigator.geolocation) {
          coordinates = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
          });
        } else {
          return alert("Sorry, but Geolocation is not supported by this browser.");
        }
      }catch(e){
        // alert(e.message);
        this.allowCurrent = false
        return false
      }
      return await this.showPosition(coordinates)
    },
    async getAddressSearch(data){
      let path = `/api/services/address/search`
      let response = await this.$http.post(path, data);
      if (response.data.result == "OK") return response.data.list
      if (response.data.result == 'ERROR') {
        this.errorMessage = response.data.message
        return []
      }
    },
    async getResults(params){
      let options = {
        url: "https://maps.googleapis.com/maps/api/geocode/json",
        params: params
      }
       let msg = await this.$http.request(options, 'GET')
       return msg
    },
    async searchAddress(q){
      let results = await this.getResults({
          libraries: 'places',
          'address': q,
          language : 'nl',
          region :'nl',
          key: config.google.mapsKey
      })
      return results.data.results.map(result => this.formatAddress(result))
    },
    async showPosition(position) {
      var lat = position.coords.latitude;
      var lng = position.coords.longitude;
      let msg = await this.getResults({latlng: lat + "," + lng, key: config.google.mapsKey })
     
      let address = this.formatAddress(msg.data.results[0],lat,lng)
      return address
    },
    formatAddress(response,lat,lng){
      let address = {current : true}
      if (!lat && response.geometry && response.geometry.location) {
        lat = response.geometry.location.lat
        lng = response.geometry.location.lng
        address.current = false
      }
      
      response.address_components.map(item=>{
        if (item.types.includes('route')) address.street = item.long_name
        if (item.types.includes('street_number')) address.number = item.long_name*1
        if (item.types.includes('postal_code')) address.zipcode = item.long_name
        if (item.types.includes('administrative_area_level_2')) address.county = item.long_name
        if (item.types.includes('locality')) address.city = item.long_name
        if (item.types.includes('administrative_area_level_1')) address.region = item.long_name
        if (item.types.includes('country')) address.country = item.long_name
      })
      if (!address.city && address.county) address.city = address.county
      if (address.zipcode) address._key = address.zipcode.replace(/ /g,'') + address.number
      address.name = address.city
      if (address.street) address.name = address.street + ' ' + (address.number || '') + ', ' +  address.city
      address.coordinate = [lat, lng]
      
      return address
    },
    dist(from, to){
      let lat1 = from[0],
      lon1 = from[1],
      lat2 = to[0],
      lon2 = to[1]
      var R = 6371 // Radius of the earth in km
      var dLat = deg2rad(lat2 - lat1) // deg2rad below
      var dLon = deg2rad(lon2 - lon1)
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) *
          Math.cos(deg2rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2)
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      var d = R * c // Distance in km
      return Math.round(d * 10) / 10 || 1000
    },
    getRegion(regions, address, base){
      let city = address.city
      let zipcode = address.zipcode
      let distance = base ? this.dist(base, address) : 1000
      let arr = regions.filter(
        (r) => r.city && r.city.length > 2 && r.city.toLowerCase() == city.toLowerCase()
      )
      if (arr.length == 0)
        arr = regions.filter(
          (r) =>
            r.zipcode && r.zipcode.length > 2 && zipcode.startsWith(r.zipcode) 
        )
      if (arr.length == 0)
        arr = regions
          .filter((r) => r.range && r.range > distance)
          .sort(sortRange)
      return arr[0]
    },
    getDeliveryPrice(regions, base, address, amount){
       if (!regions) return 0
       if (this.freeShipping) return 0
       if (!base || !address || !address.zipcode) return 0
       let region = this.getRegion(regions, address, base)
       if (!region) return -1 //HACK
       this.min = region.min
       this.max = region.max
       if (amount > this.max) return 0
       return region.cost
    },
    setAddress(regions, base, target, amount){
      let address = this.clone(target)
      if (!address) return null
      address.allow = false
      if (!regions) return 0
      address.distance = this.getDistance(base, address)
      address.price = this.getDeliveryPrice(regions, base, target, amount)
      let region = this.getRegion(regions, address, base)
      
      address.region = this.clone(region||{})
      address.min = address.region.min || 0
      address.max = address.region.max || 0
      if ((region && (!amount || amount >= address.region.min))) address.allow =  true
      
      address.blocked =  (regions && address.zipcode && regions.map(r=>r.zipcode).includes('#'+ address.zipcode)) 
      if (address.region.max > 0 && amount > 0 && address.region.max <= amount) {
        address.price = 0
        address.cost = 0
      }
      return address
    },
    getDistance(base,address) {
      if (!base || !base.coordinate || !address || !address.coordinate) return 0
      return this.dist(base.coordinate, address.coordinate)
    },
    handlePermission() {
      navigator.permissions.query({name:'geolocation'}).then(function(result) {
        console.log(result)
        if (result.state == 'granted') {
          this.report(result.state);
        } else if (result.state == 'prompt') {
          this.report(result.state);
          navigator.geolocation.getCurrentPosition(revealPosition,positionDenied,geoSettings);
        } else if (result.state == 'denied') {
          this.report(result.state);
        }
        result.onchange = function() {
          this.report(result.state);
        }
      });
    },
    report(state) {
      console.log('Permission ' + state);
    }
  },
};
function sortRange(a, b) {
  if (a.range < b.range) return -1
  if (b.range < a.range) return 1

  return 0
}
function deg2rad(deg) {
  return deg * (Math.PI / 180)
}

export default locationService;
